<template>
    <div class="pages dataReport">
        <div class="titles mb-30">
            <p>
                <img src="../../assets/images/newIcon/pepolechannel_title_icon.png" alt="">
                沉睡用户唤醒计划（场景营销计划名称）
                <span>待开始</span>
                <span>执行中</span>
                <span>待开始</span>
            </p>
            <p>
                长期计划：2021/10/10-2021/11/10，每日通知时间：18:00
            </p>
        </div>
        <div class="f2">
            <div class="d2">
                        <div class="title">
                            <div class="t1">
                                <p>
                                    <img class="log" src="../../assets/images/newIcon/numsyl.png" alt="">
                                    数据汇总
                                    <span>统计营销活动关键数据</span>
                                </p>
                                <p>
                                    <!-- <el-select style="width:100px" v-model="value" placeholder="请选择">
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.value">
                                        </el-option>
                                    </el-select> -->
                                </p>
                            </div>
                        </div>
                        <ul>
                            <li>
                                <p>
                                     <i></i>
                                    通知成功人数
                                    <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
                                        <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                    </el-tooltip>
                                </p>
                                <p>36,2414</p>
                            </li>
                             <li class="borders"><span></span></li>
                             <li>
                                <p>
                                     <i></i>
                                    访客数
                                    <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
                                        <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                    </el-tooltip>
                                </p>
                                <p>36,2414</p>
                            </li>
                             <li class="borders"><span></span></li>
                            <li>
                                <p>
                                     <i></i>
                                    下单人数
                                    <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
                                        <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                    </el-tooltip>
                                </p>
                                <p>36,2414</p>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <p>
                                     <i></i>
                                    支付人数
                                    <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
                                        <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                    </el-tooltip>
                                </p>
                                <p>36,2414</p>
                            </li>
                             <li class="borders"><span></span></li>
                             <li>
                                <p>
                                     <i></i>
                                    支付订单数
                                    <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
                                        <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                    </el-tooltip>
                                </p>
                                <p>36,2414</p>
                            </li>
                             <li class="borders"><span></span></li>
                            <li>
                                <p>
                                     <i></i>
                                    支付金额
                                    <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
                                        <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                    </el-tooltip>
                                </p>
                                <p>36,2414</p>
                            </li>
                        </ul>
            </div>
        </div>
        <el-card class="my_card" shadow="never">
            <div class="top clearfix">
                <div class="fl">
                <img
                    src="../../assets/images/newIcon/data_zhuanhua_icon.png"
                    alt=""
                />
                <span></span><b>转化效果</b><span class="text">营销转化核心节点数据统计</span>
                </div>
            </div>
            <div class="content">
                <div class="d1">
                    <span>通知-支付转化率10.00%</span> 
                    <img src="../../assets/images/newIcon/yingxiao_line_bg.png" alt="">
                </div>
                <div class="d2">
                    <span>通知-支付转化率10.00%</span> 
                    <img src="../../assets/images/newIcon/yingxiao_smallline_bg.png" alt="">
                </div>
                <div class="d3">
                    <span>通知-支付转化率10.00%</span> 
                    <img src="../../assets/images/newIcon/yingxiao_middleline_bg.png" alt="">
                </div>
                <ul>
                    <li>
                        <div class="left">
                        <div class="main">
                            <img
                            src="../../assets/images/newIcon/yingxiao_chudawhite_icon.png"
                            alt=""
                            />
                            <p>通知</p>
                        </div>
                        </div>
                        <div class="right">
                        <div>
                            <p class="fz12">推送成功人数</p>
                            <p class="fz22" style="margin-top: 10px">
                            19,359,329<span class="fz10">人</span>
                            </p>
                        </div>
                        </div>
                    </li>
                    <li>
                        <div class="left">
                        <div class="main">
                            <img
                            src="../../assets/images/newIcon/yingxiao_chudawhite_icon.png"
                            alt=""
                            />
                            <p>访客</p>
                        </div>
                        </div>
                        <div class="right">
                        <div>
                            <p class="fz12">访客人数</p>
                            <p class="fz22" style="margin-top: 10px">
                            19,359,329<span class="fz10">人</span>
                            </p>
                        </div>
                        </div>
                    </li>
                    <li>
                        <div class="left">
                        <div class="main">
                            <img
                            src="../../assets/images/newIcon/yingxiao_chudawhite_icon.png"
                            alt=""
                            />
                            <p>支付</p>
                        </div>
                        </div>
                        <div class="right">
                        <div>
                            <p class="fz12">支付人数</p>
                            <p class="fz22" style="margin-top: 10px">
                            19,359,329<span class="fz10">人</span>
                            </p>
                        </div>
                        </div>
                    </li>
                </ul>
            </div>
        </el-card>
         <!-- 3 -->
        <el-card class="my_card" shadow="never">
        <div class="top clearfix">
            <div class="fl">
            <img
                src="../../assets/images/newIcon/icon_xueshenghuaxiang_geren_gerenqingkuang_shetuanhuodongqingkuang.png"
                alt=""
            />
            <span></span><b>活动完成情况</b
            ><span class="text">营销活动每日关键数据统计</span>
            </div>
        </div>
        <!-- 表格 -->
        <el-table
            border
            :header-cell-style="{ background: '#F5F5F5', color: '#333333',textAlign: 'center',fontSize:'12px' }"
             :cell-style="{textAlign: 'center',fontSize:'12px'}"
            class="my_table1"
            :data="tableData"
            style="width: 100%"
        >
            <el-table-column prop="d1" label="日期"> </el-table-column>
            <el-table-column prop="d2" label="目标完成率"> </el-table-column>
            <el-table-column prop="d3" label="受众人群"> </el-table-column>
            <el-table-column prop="d4" label="计划触发（人数）"> </el-table-column>
            <el-table-column prop="d5" label="发送成功"> </el-table-column>
            <el-table-column prop="d6" label="目标完成"> </el-table-column>
            <el-table-column prop="d7" label="发送失败"> </el-table-column>
            <el-table-column prop="d8" label="用户拒收"> </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            background
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="  prev, pager, next,sizes, jumper"
            :total="100"
        >
        </el-pagination>
        </el-card>
        <el-card class="my_card" shadow="never">
        <div class="top clearfix">
            <div class="fl">
            <img
                src="../../assets/images/newIcon/activeanalysis_retaind_icon.png"
                alt=""
            />
            <span></span><b>活动用户后续留存</b
            ><span class="text">2021-06-16～2021-06-22过去7天参与活动的用户后续留存情况</span>
            </div>
        </div>
        <!-- 表格 -->
          <el-table
            :data="tableData3"
            :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
            style="width: 100%;"
                border
            :cell-style="cellStyle"
            >
            <el-table-column
                v-for="(item,index) in headList"
            :key="index"
            :property="item.property"
            :label="item.label"
            min-width="60"
            >
            <template slot-scope="scope">
                <p v-if="!scope.row[scope.column.property].isOk">
                    {{scope.row[scope.column.property]}}
                </p>
                <p v-if="scope.row[scope.column.property].isOk">
                    <span style="display:block;"> {{scope.row[scope.column.property].num}}人</span>
                    <span style="display:block;">{{scope.row[scope.column.property].f}}</span>
                </p>
            </template>
            <!-- <template slot-scope="scope">{{scope.row}}</template> -->
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            background
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="  prev, pager, next,sizes, jumper"
            :total="100"
        >
        </el-pagination>
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tableData: [
                {
                d1: "2018.03.05",
                d2: "7.99%",
                d3: "沉睡客户",
                d4: "100",
                d5: "10",
                d6: "100",
                d7: "10",
                d8: "100",
                },
                {
                d1: "2018.03.05",
                d2: "7.99%",
                d3: "沉睡客户",
                d4: "100",
                d5: "10",
                d6: "100",
                d7: "10",
                d8: "100",
                },
                {
                d1: "2018.03.05",
                d2: "7.99%",
                d3: "沉睡客户",
                d4: "100",
                d5: "10",
                d6: "100",
                d7: "10",
                d8: "100",
                },
                {
                d1: "2018.03.05",
                d2: "7.99%",
                d3: "沉睡客户",
                d4: "100",
                d5: "10",
                d6: "100",
                d7: "10",
                d8: "100",
                },
                {
                d1: "2018.03.05",
                d2: "7.99%",
                d3: "沉睡客户",
                d4: "100",
                d5: "10",
                d6: "100",
                d7: "10",
                d8: "100",
                },
                {
                d1: "2018.03.05",
                d2: "7.99%",
                d3: "沉睡客户",
                d4: "100",
                d5: "10",
                d6: "100",
                d7: "10",
                d8: "100",
                },
            ],
            headList:[
                {
                    label: '总体',
                    property: 'expressName'
                },
                {
                    label: '总人数',
                    property: 'num'
                },
                {
                    label: '第1天',
                    property: 'day1'
                },
                {
                    label: '第2天',
                    property: 'day2'
                },
                {
                    label: '第3天',
                    property: 'day3'
                },
                {
                    label: '第4天',
                    property: 'day4'
                },
                {
                    label: '第5天',
                    property: 'day5'
                },
                {
                    label: '第6天',
                    property: 'day6'
                },
                {
                    label: '第7天',
                    property: 'day7'
                }
            ], 
             tableData3: [
                {
                expressName: '总体',
                num:"304人",
                day1:{num:"0",f:"97.97%",isOk:true},
                day2:{num:"0",f:"97.97%",isOk:true},
                day3:{num:"0",f:"97.97%",isOk:true},
                day4:{num:"0",f:"97.97%",isOk:true},
                day5:{num:"0",f:"97.97%",isOk:true},
                day6:{num:"0",f:"97.97%",isOk:true},
                day7:{num:"0",f:"97.97%",isOk:true},
                },
                {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"28",f:"97.97%",isOk:true},
                day2:{num:"28",f:"97.97%",isOk:true},
                day3:{num:"28",f:"97.97%",isOk:true},
                day4:{num:"28",f:"97.97%",isOk:true},
                day5:{num:"28",f:"97.97%",isOk:true},
                day6:{num:"28",f:"97.97%",isOk:true},
                day7:{num:"28",f:"97.97%",isOk:true},
                },
                 {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"28",f:"97.97%",isOk:true},
                day2:{num:"28",f:"97.97%",isOk:true},
                day3:{num:"28",f:"97.97%",isOk:true},
                day4:{num:"28",f:"97.97%",isOk:true},
                day5:{num:"28",f:"97.97%",isOk:true},
                day6:{num:"28",f:"97.97%",isOk:true},
                day7:{num:"28",f:"97.97%",isOk:true},
                },
                 {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"28",f:"97.97%",isOk:true},
                day2:{num:"28",f:"97.97%",isOk:true},
                day3:{num:"28",f:"97.97%",isOk:true},
                day4:{num:"28",f:"97.97%",isOk:true},
                day5:{num:"28",f:"97.97%",isOk:true},
                day6:{num:"28",f:"97.97%",isOk:true},
                day7:{num:"28",f:"97.97%",isOk:true},
                },
                 {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"28",f:"97.97%",isOk:true},
                day2:{num:"28",f:"97.97%",isOk:true},
                day3:{num:"28",f:"97.97%",isOk:true},
                day4:{num:"28",f:"97.97%",isOk:true},
                day5:{num:"28",f:"97.97%",isOk:true},
                day6:{num:"28",f:"97.97%",isOk:true},
                day7:{num:"28",f:"97.97%",isOk:true},
                },
                 {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"",f:"97.97%",isOk:true},
                day2:{num:"28",f:"97.97%",isOk:true},
                day3:{num:"28",f:"97.97%",isOk:true},
                day4:{num:"28",f:"97.97%",isOk:true},
                day5:{num:"28",f:"97.97%",isOk:true},
                day6:{num:"28",f:"97.97%",isOk:true},
                day7:{num:"28",f:"97.97%",isOk:true},
                },
                 {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"28",f:"97.97%",isOk:true},
                day2:{num:"28",f:"97.97%",isOk:true},
                day3:{num:"28",f:"0%",isOk:true},
                day4:{num:"0",f:"0%",isOk:true},
                day5:{num:"0",f:"0%",isOk:true},
                day6:{num:"0",f:"0%",isOk:true},
                day7:{num:"0",f:"0%",isOk:true},
                },
                 {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"28",f:"0%",isOk:true},
                day2:{num:"28",f:"0%",isOk:true},
                day3:{num:"0",f:"0%",isOk:true},
                day4:{num:"0",f:"0%",isOk:true},
                day5:{num:"0",f:"0%",isOk:true},
                day6:{num:"0",f:"0%",isOk:true},
                day7:{num:"0",f:"0%",isOk:true},
                }
             ]
        }
    },
    methods:{
         cellStyle({ row, column, rowIndex, columnIndex }) {
            // console.log(row[column.property],11111);
            let is=false;
            if (row[column.property].isOk && columnIndex>1) {
                if(row[column.property].num>0 || parseFloat(row[column.property].f)>0){
                   return `background:#90B5FF;color:#081BA9;fontSize:12px;textAlign:center`;
                }else{
                    return `fontSize:12px;textAlign:center;`
                }
            } else {
                return `fontSize:12px;textAlign:center;`
            }
        },
    }
}
</script>
<style lang="less" scoped>
    .dataReport{
        .titles{
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            p{
                &:first-of-type{
                    img{
                        width:23px;
                        vertical-align: middle;
                    }
                    span{
                        margin-right:10px;
                        padding:4px 10px;
                        display: inline-block;
                        font-size: 14px;
                        font-weight: 400;
                        border-radius: 2px;
                        &:first-of-type{
                            background: rgba(194, 128, 255, 0.3);
                            color:#A240FC
                        }
                        &:nth-child(3){
                            background: rgba(250, 100, 0, 0.3);
                            color:#FA6400;
                        }
                        &:nth-child(4){
                            background: rgba(109, 212, 0, 0.3);
                            color:#468602;
                        }
                    }
                }
                &:last-of-type{
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                }
            }
        }
        .f2{
            .d2{
                 box-sizing: border-box;
                padding:30px;
                padding-bottom:0;
                border-radius: 10px;
                background: #fff;
                .borders{
                    display: flex;
                    align-items: flex-end;
                    span{
                        display: inline-block;
                            width:1px;
                        height:100%;
                        background: #e6e6e6;
                    }
                    
                }
                ul{
                    width:70%;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    li{
                        margin-bottom:30px;
                        text-align: left;
                        // width:33.3%;
                        box-sizing: border-box;
                        p{
                            i{
                                display: inline-block;
                                width: 4px;
                                height: 12px;
                                background: #327EFF;
                                border-radius: 2px;
                            }
                            padding-bottom:10px;
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(37, 49, 62, 0.85);
                            img{
                                width:16px;
                                vertical-align: middle;
                            }
                            &:nth-child(2){
                                padding-bottom:0;
                                margin-left:10px;
                               font-size: 29px;
                                font-weight: bold;
                                color: #171E26;
                            }
                            // &:last-child{
                            //     padding:0;
                            //     font-size: 12px;
                            //     font-weight: 400;
                            //     color: #7E858C;
                            //     span{
                            //         padding-left:10px;
                                    
                            //     }
                            //     //  border-right:1px solid #ccc;
                            // }
                        
                        }
                        &:nth-child(3n){
                            display: flex;
                            flex-direction: column;
                            align-items: flex-end;
                            // text-align: right;
                            p{
                                width:110px;
                                border:0px;
                            }
                        }
                        &:nth-child(2){
                            // width:38.3%;
                            // text-align: center;
                        }
                        &:nth-child(5){
                            // width:38.3%;
                            // text-align: center;
                        }
                    }
                }
            }
        }
        .title{
            margin-bottom:30px;
            .t1{
                display: flex;
                justify-content: space-between;
                p{
                    .log{
                        width:20px;
                    }
                    img{
                        width:16px;
                        vertical-align: middle;
                        margin-right:10px;
                    }
                    /deep/ .el-input .el-input__inner{
                        background: #F6F6F9;
                        border:0px;
                    }
                    span{
                        padding-left:10px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #999999;
                        
                    }
                }
            }
            .t2{
                margin-top:12px;
                font-size: 12px;
                font-weight: 400;
                color: #333333;
            }
        }
        .top {
            margin-top: 20px;
            .fl {
            float: left;
            font-size: 16px;
            display: flex;
            b {
                margin-left: 6px;
            }
            img {
                width: 24px;
            }
            .text {
                margin-left: 12px;
                color: #999999;
                font-size: 12px;
                line-height: 24px;
            }
            .tip1,
            .tip2,
            .tip3 {
                display: inline-block;
                width: 60px;
                height: 24px;
                background: rgba(194, 128, 255, 0.3);
                color: #a240fc;
                border-radius: 2px;
                margin-left: 5px;
                text-align: center;
                line-height: 24px;
                font-weight: 400;
                font-size: 14px;
            }
            .tip2 {
                background: rgba(250, 100, 0, 0.3);
                color: #fa6400;
            }
            .tip3 {
                background: rgba(109, 212, 0, 0.3);
                color: #468602;
            }
            }
            .fr {
            float: right;
            color: #999999;
            font-size: 12px;
            }
        }
        .my_card {
            margin-top: 20px;
            .top {
            margin-top: 0;
            }
            .content{
                position: relative;
                .d1,.d2,.d3{
                    position: absolute;
                    display: flex;
                    align-items: center;
                    span{
                        margin-right:10px;
                        display: inline-block;
                        width:50px;
                        font-size: 10px;
                        line-height: 16px;
                        font-weight: 400;
                        color: #333333;
                    }
                }
                .d1{
                    img{
                        width:142px;
                        height:254px;
                    }
                    top: 18px;
                    left: 25px;
                }
                .d2{
                    top: 158px;
                    left: 95px;
                    img{
                        width:68px;
                        height:74px;
                    }
                }
                .d3{
                    top: 36px;
                    left: 96px;
                    img{
                        width:56px;
                        height:105px;
                    }
                }
            }
            &:nth-child(2) {
            ul {
                margin-top: 20px;
                display: flex;
                li {
                margin-left: 300px;
                position: relative;
                &::after {
                    position: absolute;
                    top: 5px;
                    right: -150px;
                    content: "";
                    width: 1px;
                    height: 45px;
                    background-color: #e6e6e6;
                }
                &:first-child {
                    margin-left: 15px;
                }
                &:last-child::after {
                    content: none;
                }
                }
            }
            }
            &:nth-child(3) {
            ul {
                margin-top: 30px;
                margin-left: 198px;
                li {
                display: flex;
                .fz12{
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(37, 49, 62, 0.85);
                }
                .fz22{
                    font-size: 22px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    color: #171E26;
                    span{
                        font-size:10px;
                    }
                }
                &:nth-child(1) {
                    .left {
                    .main {
                        text-align: center;
                        margin-left: 0;
                        margin-top: -65px;
                        img {
                        width: 22px;
                        }
                        p {
                        color: #fff;
                        font-size: 12px;
                        letter-spacing: 1px;
                        }
                    }
                    border-top: 90px solid;
                    border-top-color: #7898ff;
                    border-left: 10px solid transparent;
                    border-right: 10px solid #ebecfc;
                    height: 0;
                    width: 160px;
                    border-radius: 0;
                    }
                    .right {
                    margin-right: 100px;
                    flex: 1;
                    background-color: #ebecfc;
                    position: relative;
                    > div {
                        position: absolute;
                        top: 20px;
                        right: 0;
                        width: 200px;
                        text-align: left;
                    }
                    }
                }
                &:nth-child(2) {
                    margin-top: 5px;
                    margin-left: 10px;
                    .left {
                    .main {
                        text-align: center;
                        margin-left: 0;
                        margin-top: -65px;
                        img {
                        width: 22px;
                        }
                        p {
                        color: #fff;
                        font-size: 12px;
                        letter-spacing: 1px;
                        }
                    }
                    border-top: 90px solid;
                    border-top-color: #61e6df;
                    border-left: 10px solid transparent;
                    border-right: 10px solid #f2f2f2;
                    height: 0;
                    width: 140px;
                    border-radius: 0;
                    }
                    .right {
                    margin-right: 100px;
                    flex: 1;
                    background-color: #f2f2f2;
                    position: relative;
                    > div {
                        position: absolute;
                        top: 20px;
                        right: 0;
                        width: 200px;
                        text-align: left;
                    }
                    }
                }
                &:nth-child(3) {
                    margin-top: 5px;
                    margin-left: 20px;
                    .left {
                    .main {
                        text-align: center;
                        margin-left: 0;
                        margin-top: -65px;
                        img {
                        width: 22px;
                        }
                        p {
                        color: #fff;
                        font-size: 12px;
                        letter-spacing: 1px;
                        }
                    }
                    border-top: 90px solid;
                    border-top-color: #FEA24F;
                    border-left: 10px solid transparent;
                    border-right: 10px solid #faf0ed;
                    height: 0;
                    width: 120px;
                    border-radius: 0;
                    }
                    .right {
                    margin-right: 100px;
                    flex: 1;
                    background-color: #faf0ed;
                    position: relative;
                    > div {
                        
                        position: absolute;
                        top: 20px;
                        right: 0;
                        width: 200px;
                        text-align: left;
                    }
                    }
                }
                }
            }
            }
            &:nth-child(4),
            &:nth-child(5) {
            //表格
            .el-table {
                border: 1px solid transparent;
            }
            .top{
                padding:15px 20px;
            }
            /deep/ .el-card__body{
                padding:0;
            }
            .my_table1 {
                // margin-top: 10px;
                .cell {
                text-align: center;
                font-size: 12px;
                padding-left: 0;
                }
                .el-table__row {
                height: 65px;
                }
            }
            //分页
            .el-pagination {
                margin: 20px 0;
            }
            .el-pagination__jump {
                margin-left: 0;
            }
            }
            &:nth-child(5) {
            .tableBox {
                position: relative;
                .wenzi {
                z-index: 1;
                position: absolute;
                top: 171px;
                left: 204px;
                width: 137px;
                height: 71px;
                background: #ffffff;
                padding: 11px 5px 9px 12px;
                box-sizing: border-box;
                box-shadow: 0px 2px 11px 0px rgba(129, 129, 129, 0.5);
                border-radius: 4px;
                font-size: 12px;
                }
            }
                .el-table--mini td,
                .el-table--mini th {
                padding: 0px 0;
                }
            .endp {
                margin-top: 10px;
                font-size: 12px;
            }
            .my_table1 {
                margin-top: 20px;
            
                .cellStyle {
                display: inline-block;
                width: 130px;
                height: 65px;
                background-color: #90b5ff;
                line-height: 65px;
                text-align: center;
                color: #0013a5;
                }
            }
            }
        }
    }
</style>